import Cookies from 'js-cookie'
import Login from '../components/Login.vue'
import MainLayout from '../layouts/MainLayout.vue'
import { createRouter, createWebHashHistory } from 'vue-router'

// 页面组件 - 修改后的组件导入（添加前缀）
import AppDashboard from '../views/Dashboard.vue'


import PlatformManagement from '../views/PlatformManagement.vue'

import MaterialGallery from '../views/material/Gallery.vue'

import SystemPublish from '../views/system/Publish.vue'
import SmsManagement from '../views/system/SmsManagement.vue'
import SystemOssConfig from '../views/system/OssConfig.vue'

import UserManagement from '../views/store/UserManagement.vue'
import BusinessCardManagement from '../views/store/BusinessCardManagement.vue'

import NumberManagement from '../views/NumberManagement.vue'

import AccountManagement from '../views/txad/AccountManagement.vue'
import AdvertiserManagement from '../views/txad/AdvertiserManagement.vue'
import ScheduledDelivery from '../views/txad/ScheduledDelivery.vue'
import CustomAudienceManagement from '../views/txad/CustomAudienceManagement.vue'

import EmailAccount from '../views/email/EmailAccount.vue'
import EmailTemplate from '../views/email/EmailTemplate.vue'
import EmailTestRecord from '../views/email/EmailTestRecord.vue'
import ScheduledEmail from '../views/email/ScheduledEmail.vue'

import WechatAccount from '../views/wxmessage/WechatAccount.vue'
import WechatScheduled from '../views/wxmessage/WechatScheduled.vue'

import SmsAccount from '../views/sms/SmsAccount.vue'
import SmsScheduled from '../views/sms/SmsScheduled.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      // 控制台
      {
        path: 'dashboard',
        name: 'AppDashboard',  // 修改名称
        component: AppDashboard
      },


      {
        path: 'NumberManagement',
        name: 'NumberManagement',
        component: NumberManagement
      },


      // 腾讯广告
      {
        path: 'txad',
        children: [
          {
            path: 'account',
            name: 'AccountManagement',
            component: AccountManagement
          },
          {
            path: 'Advertiser',
            name: 'AdvertiserManagement',
            component: AdvertiserManagement
          },
          {
            path: 'CustomAudienceManagement',
            name: 'CustomAudienceManagement',
            component: CustomAudienceManagement
          },
          {
            path: 'ScheduledDelivery',
            name: 'ScheduledDelivery',
            component: ScheduledDelivery
          }

        ]
      },


      // 素材管理
      {
        path: 'material',
        children: [

          {
            path: 'gallery',
            name: 'MaterialGallery',
            component: MaterialGallery
          }
        ]
      },


      // 短信营销
      {
        path: 'sms',
        children: [

          {
            path: 'SmsAccount',
            name: 'SmsAccount',
            component: SmsAccount
          },
          {
            path: 'SmsScheduled',
            name: 'SmsScheduled',
            component: SmsScheduled
          }
        ]
      },
      // 素材管理
      {
        path: 'store',
        children: [

          {
            path: 'usermanagement',
            name: 'UserManagement',
            component: UserManagement
          },
          {
            path: 'businesscard',
            name: 'BusinessCardManagement',
            component: BusinessCardManagement
          }
        ]
      },

      {
        path: 'wxmessage',
        children: [

          {
            path: 'WechatAccount',
            name: 'WechatAccount',
            component: WechatAccount
          },
          // 新增微信定时任务路由
          {
              path: 'WechatScheduled',
              name: 'WechatScheduled',
              component: WechatScheduled
          }
        ]
      },


      {
        path: 'email',
        children: [
          {
            path: 'EmailAccount',
            name: 'EmailAccount',
            component: EmailAccount
          },
          {
            path: 'EmailTemplate',
            name: 'EmailTemplate',
            component: EmailTemplate
          },
          {
            path: 'ScheduledEmail',
            name: 'ScheduledEmail',
            component: ScheduledEmail
          },
          {
            path: 'EmailTestRecord',
            name: 'EmailTestRecord',
            component: EmailTestRecord
          }
        ]
      },

      // 系统配置
      {
        path: 'system',
        children: [

          {
            path: 'publish',
            name: 'SystemPublish',
            component: SystemPublish
          },
          {
            path: 'OssConfig',
            name: 'SystemOssConfig',
            component: SystemOssConfig
          },
          {
            path: 'platform',
            name: 'PlatformManagement',
            component: PlatformManagement
          },
          {
            path: 'smsmanagement',
            name: 'SmsManagement',
            component: SmsManagement
          }
        ]
      }
    ]
  }
]


const router = createRouter({
  history: createWebHashHistory('/shop/'),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = Cookies.get('user_token')
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isLoginPage = to.path === '/login'

  // 认证检查逻辑
  if (requiresAuth) {
    if (isAuthenticated) {
      // 已认证访问管理后台
      if (to.path === '/') {
        // 默认跳转控制台
        next('/dashboard')
        return
      }
      next()
    } else {
      // 未认证重定向到登录页
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } else if (isLoginPage) {
    // 登录页特殊处理
    if (isAuthenticated) {
      next('/dashboard') // 已登录强制跳转控制台
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router